DialogController = App.loadClass 'core::Angular/DialogController'

class exports.AddQuoteController extends DialogController
    constructor: (@scope, @transitions, @data, @modalInstance) ->
        super(@scope, @transitions, @modalInstance)

        @scope.title = 'Add New Quote'
        @scope.quote = ''
        @scope.selected =
            quotee: null

        @loadScopeData @data.getQuotablePersons(), 'quotablePersons'

    save: () =>
        @data.saveQuote(@scope.quote, @scope.selected.quotee).then (response) =>
            @closeWithAlert(response.data.status)
